import React from 'react'
import "./PcLogin.less";
import { appMethod as app } from '@utils/app';
import OfficialPage from '../../official-page/OfficialPage';
import { Toast } from 'antd-mobile';

let step2timer = null;
export default class PcLogin extends OfficialPage {
  state = {
    codeImg: '',
    timer: null,
    requestNum: 1,
    totalRequestNum: 15,
    tNum: 1,
    areaCode: 0,
    phoneNumber: '',
    picCode: '',
    picCodeUrl: '/index.php?r=Login/GetNewIdentifyCode&i=' + parseInt(Math.random() * 10000000),
    identifyCode: '',
    verifying: false,
    step2time: 60,
    isAgreement: false,
    logining: false
  }
  constructor(props) {
    super(props);
    document.title = '即速登录';
  }
  componentDidMount () {
    if (app.isLogin()) {
      app.turnToPage('jisuSession');
      return;
    }
    this.getLoginQrcode();
  }
  componentWillUnmount = () => {
    this.setState = ()=>{
      return;
    };
    clearTimeout(this.state.timer);
  }
  getLoginQrcode = () => {
    let that = this;
    app.sendRequest({
      url: '/index.php?r=Login/loginQrcode',
      data: {
        app_id: app.getAppId()
      },
      complete: (res) => {
        if (res && res.status == 0) {
          that.setState({
            codeImg: res.data
          })
        }else{
          Toast.fail('二维码请求失败,请检查相关配置');
        }
      }
    })
    that.setState({
      requestNum: 1
    })
    that.cometRequest();
  }
  cometRequest = () => {
    let that = this;
    let { requestNum, tNum, totalRequestNum, timer } = this.state;
    app.sendRequest({
      url: '/index.php?r=Login/CheckLogin',
      data: {
        app_id: app.getAppId()
      },
      complete: (res) => {
        if (res.status == 0) {
          if (res.is_complete == 1){  //  is_complete=1 表示手机号已存在
						// 直接登录
            app.setIsLogin(true);
            app.turnToPage('jisuSession');
					} else if (res.is_complete == 2) { 
            // 未登录，注册第二步
            app.showModal({
              content: '您还没有注册账号，请前往注册',
              confirmText: '去注册',
              showCancel: true,
              confirmColor: '#437eff',
              confirm: () => {
                app.turnToPage('register-pc?step=2');
              },
            })
          }
        }else if(res.status == 1){
          if(requestNum < totalRequestNum){
            let num = requestNum + 1;
            if (timer) {
              clearTimeout(timer);
            }
            let timeout = setTimeout(() => {
              that.cometRequest();
            }, 5000)
            that.setState({
              timer: timeout,
              requestNum: num
            })
          }else{
            if(tNum < 5){
              let num = tNum + 1;
              that.getLoginQrcode();
              that.setState({
                tNum: num
              })
            }
          }
        }
      },
			fail: () => { //Ajax请求超时，继续查询
				setTimeout(() => {
          that.cometRequest();
        }, 5000)
			}
    })
  }
  // 处理input的值的更改
  handleChange = (name, event) => {
    this.setState({
      [name]: event.target.value
    });
  }
  // 更换图形验证码
  getPicCode = () => {
    this.setState({
      picCodeUrl: '/index.php?r=Login/GetNewIdentifyCode&i=' + parseInt(Math.random() * 10000000)
    })
  }
  // 获取验证码
   getIdentifyCode = () => {
    if (this.state.verifying) {
      return;
    }
    if (!this.state.phoneNumber) {
      Toast.info('请输入手机号');
      return;
    }
    if (this.state.phoneNumber.includes(' ')) {
      Toast.info('手机号不能有空格');
      return;
    }
    if (!this.state.picCode) {
      Toast.info('请输入图形验证码');
      return;
    }
    this.setState({
      verifying: true,
      step2time: 60
    });
    let that = this;
    const phone = +this.state.areaCode === 0 ? this.state.phoneNumber : `${ AREA_CODE[this.state.areaCode] }-${ this.state.phoneNumber }`;
    app.sendRequest({
      url: '/index.php?r=AppUser/phoneCode',
      data: {
        app_id: app.getAppId(),
        phone,
        pic_code: that.state.picCode,
      },
      complete: (res) => {
        if (res.status !== 0) {
          // Toast.fail(res.data);
          that.setState({
            verifying: false,
            step2time: 60
          });
          return;
        }
        step2timer = setInterval(() => {
          if (that.state.step2time === 0) {
            clearInterval(step2timer);
            that.setState({
               verifying:  false,
              step2time: 60
            });
          }
          that.setState({
            step2time: --that.state.step2time
          })
        }, 1000);
      }
    })
  }
  handleLogin = () => {
    if (this.state.logining) {
      return;
    }
    if (!this.state.phoneNumber) {
      Toast.info('请输入手机号');
      return;
    }
    if (this.state.phoneNumber.includes(' ')) {
      Toast.info('手机号不能有空格');
      return;
    }
    if (!this.state.identifyCode) {
      Toast.info('请输入验证码');
      return;
    }
    if (!this.state.isAgreement) {
      Toast.info('请同意咫尺网络用户注册协议');
      return;
    }
    this.setState({
      logining: true
    });
    const phone = +this.state.areaCode === 0 ? this.state.phoneNumber : `${ AREA_CODE[this.state.areaCode] }-${ this.state.phoneNumber }`;
    app.sendRequest({
      url: '/index.php?r=AppUser/phoneReg',
      data: {
        app_id: app.getAppId(),
        phone,
        code: this.state.identifyCode,
      },
      complete: (res) => {
        if (res.status !== 0) {
          this.setState({
            logining: false
          });
          // Toast.fail(res.data);
          return;
        }
        app.setIsLogin(true);
        app.bindUserAccount();
        // 请求用户数据存到本地
        app.requestUserInfo().then(() => {
          Toast.info('登录成功',1);
          let timer = setTimeout(() => {
            if(timer){
              clearTimeout(timer)
            }
            app.turnToPage('jisuSession');
          },1000)
        });
      },
      fail: () => {
        this.setState({
          logining: false
        });
        // Toast.fail(res.data);
      }
    })
  }
  checkboxChange = event => {
    let checked = event.target.checked;
    this.setState({
      isAgreement: checked
    })
  }
  goRegister = () => {
    app.turnToPage('register-pc');
  }
  render() {
    let { codeImg, isAgreement } = this.state;
    return (
      <div className='pcdl_page'>
        <div className='header'>
          <div className='head_con'>
            <div className='row'>
              <span className='page_t'>即速对话</span>
            </div>
          </div>
        </div>
        <div className='main'>
          <div className='main_l'>
            <div className='box'>
              <div className='main_title'>微信登录</div>
              <div className='main_con'>
                {codeImg != '' && <img src={codeImg} className='zc_code' />}
              </div>
            </div>
          </div>
          <div className='main_r'>
            <div className='box'>
              <div className='main_title'>账号登录</div>
              <div className='main_con'>
                <div className="login_phone">
                  <select value={this.state.areaCode} onChange={this.handleChange.bind(this, 'areaCode')}>
                    <option value="0">中国大陆+86</option>
                    <option value="8">Malaysia+60</option>
                  </select>
                  <input type="text" placeholder="请输入手机号" value={this.state.phoneNumber} onChange={this.handleChange.bind(this, 'phoneNumber')}/>
                </div>
                <div className="login_GraphocVerification">
                  <input type="text" placeholder="请输入验证码" value={this.state.picCode} onChange={this.handleChange.bind(this, 'picCode')}/>
                  <img className="pic_code" src={this.state.picCodeUrl} onClick={this.getPicCode}  />
                </div>
                <div className='short_message_code'>
                  <input type="text" placeholder="请输入动态密码" value={this.state.identifyCode} onChange={this.handleChange.bind(this, 'identifyCode')}/>
                  <div className="get_code" onClick={this.getIdentifyCode} >{(this.state.verifying && this.state.step2time !== 60) ? this.state.step2time + 's' : '获取动态密码' }</div>
                </div>
                <div className='line1'>
                  <span onClick={this.goRegister}>注册账号</span>
                </div>
                <div className='line2'>
                  <input type="checkbox" checked={isAgreement} onChange={this.checkboxChange}/>
                  <span>同意</span>
                  <a href="http://www.jisuapp.cn/index.php?r=Login/UserProtocal" target="_blank">《咫尺网络用户注册协议》</a>
                </div>
                <div className='sub_btnbox'>
                  <div className='sub_btn' onClick={this.handleLogin}>登录</div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/chatgpt-page/pc-login/PcLogin.jsx